<template>
  <div
    class="bekki-user-message bg-primary text-body-1 text-pre-line align-self-end px-4 rounded-be-0"
    data-cc="bekki-message"
    data-state="user"
  >
    {{ text }}
  </div>
</template>

<script setup lang="ts">
interface Props {
  text: string;
}

defineProps<Props>();
</script>

<style scoped>
.bekki-user-message {
  max-width: 75%;
  padding-block: 10px;
  border-radius: 18px;
  overflow-wrap: anywhere;
}
</style>
